var apiClient = null;
  if (window.ShopifyStorefrontAPIClient) {
    apiClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
      storeDomain: "subellahair-2557.myshopify.com",
      apiVersion: "2025-01",
      publicAccessToken: "60c504fcdd0620d943b71374591aa5e8"
    });
  }

function copyToClipboard(e) {
	var i = document.createElement("textarea");
	i.value = e, i.setAttribute("readonly", ""), i.style.position = "absolute", i.style.left = "-9999px", document.body.appendChild(i);
	var t = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
	i.select(), document.execCommand("copy"), document.body.removeChild(i), t && (document.getSelection().removeAllRanges(), document.getSelection().addRange(t))
}

function copyCode(e) {
	var i = e.target;
	copyToClipboard(i.getAttribute("data-code")), i.innerText = "copied!", setTimeout(function() {
		i.innerText = "copy"
	}, 1500)
}
$(function () {
   var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
  function sendLocalProinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
   function sendSwiperClickdata(idselect,index){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_select_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }
    function sendSwiperViewdata(idselect,index){
                   $(idselect).eq(index).each(function(){
                           var imgitems=new Array();
                           var csl=index;
                            var iid = "homepage_swiper-slide-banner_image";
                            var pid = "homepage_swiper-slide-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_view_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
  }
  var flag = {};
var mySwiper = new Swiper('#pcSwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on:{
    slideChangeTransitionEnd:function(event){
        var pcswiperCon = document.getElementById("pcSwiper");
        if(GAiiv(pcswiperCon)){
         var img_index = this.realIndex;
          var pcSelection = "#swiper-ga4-push-pc .slide-content-p";
          if(flag[img_index] !== img_index){
            sendSwiperViewdata(pcSelection,img_index);
            flag[img_index] = img_index;
          }    
      }
    }
  }
})
  $("#pcSwiper .swiper-slide").click(function(){
    var indexReal = mySwiper.realIndex;
    var pcSelection = "#swiper-ga4-push-pc .slide-content-p";
    var promotionid ="homepage_swiper-slide-banner_image";
    var promoname ="";
     promoname =  $(pcSelection).eq(indexReal).find("img").attr("alt");
     if(promoname == "" || promoname == null){
       promoname = "Swiper Slide IMG"+indexReal;
    }
    sendLocalProinfo(promotionid,promoname);
    sendSwiperClickdata(pcSelection,indexReal);
})
  
var imgflag ={};
var mySwipers = new Swiper('#mobSwiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  }, 
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  on:{
    slideChangeTransitionEnd:function(event){
        var mobswiperCon = document.getElementById("mobSwiper");
        if(GAiiv(mobswiperCon)){  
           img_index = this.realIndex;
           var pcSelection = "#swiper-ga4-push-mob .slide-content-m";
          if(imgflag[img_index] !== img_index){
             sendSwiperViewdata(pcSelection,img_index);
            imgflag[img_index] = img_index;
          }
      }
    }
  }
})
  $("#mobSwiper .swiper-slide").click(function(){
      var indexReal = mySwipers.realIndex;
      var mobSelection = "#swiper-ga4-push-mob .slide-content-m";
      var promotionid ="homepage_swiper-slide-banner_image";
      var promoname ="";
      $(mobSelection).eq(indexReal).each(function(){
       var promoname = $(this).find("img").attr("alt");
     });
    promoname =  $(mobSelection).eq(indexReal).find("img").attr("alt");
     if(promoname == "" || promoname == null){
       promoname = "Swiper Slide IMG"+indexReal;
    }
    sendLocalProinfo(promotionid,promoname);
    sendSwiperClickdata(mobSelection,indexReal);
  })
})
window.timeZoneParams = -7;
window.getLocalTime = function (i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
}
window.getNextDate = function(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
};
window.endTimeFn = function() {
    var date = getLocalTime(timeZoneParams);
    var dateYear = date.getFullYear();
    var dateMonth = date.getMonth() + 1;
    var dateDate = date.getDate();
    var date2 = getNextDate(dateYear+'/'+dateMonth+'/'+ dateDate,1);
    var blackLimitTime = new Date(date2).getTime() - date;
    return blackLimitTime;
}
//Flash Sale Home Page
$(function () {
    var flasDate = getLocalTime(timeZoneParams);
    var flashWeek = flasDate.getDay();
    if(flashWeek==0){
        flashWeek=7;
    }
    var flash_start_time = '2022/9/20 00:00:00';
    var flash_end_time = '2030/9/20 00:00:00' ;
    if(typeof flash_start_time != 'undefined'){
                      var date = getLocalTime(timeZoneParams);
                      var startFlashTime =new Date(flash_start_time);
                      var endFlashTime =new Date(flash_end_time);
                      var endAllFlashTime = endFlashTime.getTime() -date;
                      var allFlashTime = startFlashTime.getTime() - date;
                      function timerFlash(intDiff){
                          var day=0,
                              hour=0,
                              minute=0,
                              second=0;
                          intDiff = intDiff - 0;
                          if(intDiff > 0){
                              hour = Math.floor(intDiff /1000/60/60);
                              minute = Math.floor(intDiff /1000/60%60);
                              second =  Math.floor(intDiff/1000%60);
                          }
                          if(hour<10){
                              $('.home-flashClock_time--H .home-flashClock_time--num').text('0' + hour);
                          }else {
                              $('.home-flashClock_time--H .home-flashClock_time--num').text( hour);
                          }
                          if(minute<10){
                              $('.home-flashClock_time--M .home-flashClock_time--num').text('0' + minute);
                          }else {
                              $('.home-flashClock_time--M .home-flashClock_time--num').text(minute);
                          }
                          if(second<10){
                              $('.home-flashClock_time--S .home-flashClock_time--num').text('0' + second);
                          }else {
                              $('.home-flashClock_time--S .home-flashClock_time--num').text(second);
                          }
                      }
                      var startFlashFlag = true;
                      var endFlashFlag = true;
                      var endAllFlashTimeToday;
                      var limitFlashTime = setInterval(function(){
                          if(allFlashTime > 0){
                         
                              if(startFlashFlag){
                                  $('.home-flash_clock').hide();
                                  startFlashFlag = false;
                              }
                              allFlashTime = allFlashTime -1000;
                              // timerFlash(allFlashTime);
                          }else{
                              if(endFlashFlag){
                                  endAllFlashTime = endFlashTime.getTime() - date;
                                  endAllFlashTimeToday = endTimeFn();
                                  endFlashFlag = false;
                              }
                              if(endAllFlashTime > 0){
                                  $('.home-flash_clock').show();
                                  endAllFlashTime = endAllFlashTime - 1000;
                                  endAllFlashTimeToday = endAllFlashTimeToday - 1000;
                                  timerFlash(endAllFlashTimeToday);
                                  if(endAllFlashTimeToday < 0){
                                      endAllFlashTimeToday = endTimeFn();
                                  }
                              }else {
                                  clearInterval(limitFlashTime);
                              }
                          }
                      },1000);
            }
})
 $(function(){
    var offset = 100;
    var speed = 250;
    var duration = 500;
        $(window).scroll(function(){
            if ($(this).scrollTop() < offset) {
                      $('#footer-back-to-top') .fadeOut(duration);
            } else {
                      $('#footer-back-to-top') .fadeIn(duration);
            }
        });
     $('#footer-back-to-top').on('click', function(){
            $('html, body').animate({scrollTop:0}, speed);
            return false;
            });
});
$(document).ready(function() {
            // 获取DOM元素
            const tocToggle = $('.mob-tab-content');
            const mobileToc = $('.mobile-toc-tabcontent');
            const overlay = $('.mobile-toc-overlay');
            const closeBtn = $('.common-closebtn');
            
            // 显示目录和遮罩层
            function showToc() {
                mobileToc.addClass('active');
                overlay.fadeIn(300);
                // 禁用滚动
                // $('body').css('overflow', 'hidden');
            }
            
            // 隐藏目录和遮罩层
            function hideToc() {
                mobileToc.removeClass('active');
                overlay.fadeOut(300);
                // 恢复滚动
                // $('body').css('overflow', 'auto');
            }
            
            // 按钮点击事件
            tocToggle.click(function(e) {
                e.stopPropagation();
                showToc();
            });
            
            // 关闭按钮事件
            closeBtn.click(function() {
                hideToc();
            });
            
            // 遮罩层点击事件
            overlay.click(function() {
                hideToc();
            });
            
            // 点击目录外区域关闭
            $(document).click(function(e) {
                if (!$(e.target).closest('.mobile-toc-tabcontent').length && 
                    !$(e.target).is(tocToggle)) {
                    hideToc();
                }
            });
            
            // 阻止目录内部点击关闭
            mobileToc.click(function(e) {
                e.stopPropagation();
            });
            
            // 移动端目录链接点击后也关闭
            mobileToc.find('a').click(function() {
                hideToc();
            });
        });
$(function () {
   var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
      }

  function sendProlistname(prolistname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
           localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: prolistname
                    }));
}
      function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
    function gaviewproducts(bselection,proitems,btitle,arrflag){
     $(bselection).each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".grid-product__price--current .grid-product__price--from .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&arrflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": btitle,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              arrflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
  // product list ga4 click push
  function clickpushproduct(thisobj,prolistname){
     var protitleshow = $(thisobj).find(".real-product-title").text();
                 var proidshow = $(thisobj).find(".productid_ga4").text();
                 var product_sku = $(thisobj).find(".productsku_ga4").text();
                 var product_realsku = $(thisobj).find(".productsku2_ga4").text();
                 if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                    product_realsku = "not set";
                 }
                 var propriceshow = $(thisobj).find(".grid-product__price--current .grid-product__price--from .money").text().replace(/[^0-9.]/g, '');
                 var provariantshow = $(thisobj).find(".productvariant_ga4").text();
                 var proindexshow = $(thisobj).index();
                 var proquantityshow = 1;
                 var procurrencyshow = "USD";
                 var procategoryshow = $(thisobj).find(".productcategory_ga4").text();
                 sendProlistname(prolistname);
                 sendProindex(proidshow,prolistname,proindexshow);

                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                             "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }
   // ga4 push product info
    function gaviewflashsale(bselection,proitems,btitle,arrflag){
     $(bselection).each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".home-flash_content .price-box .price-box_price .price .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&arrflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": btitle,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              arrflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
  // product list ga4 click push
  function clickpushflashpro(thisobj,prolistname){
     var protitleshow = $(thisobj).find(".real-product-title").text();
                 var proidshow = $(thisobj).find(".productid_ga4").text();
                 var product_sku = $(thisobj).find(".productsku_ga4").text();
                 var product_realsku = $(thisobj).find(".productsku2_ga4").text();
                 if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                    product_realsku = "not set";
                 }
                 var propriceshow = $(thisobj).find(".home-flash_content .price-box .price-box_price .price .money").text().replace(/[^0-9.]/g, '');
                 var provariantshow = $(thisobj).find(".productvariant_ga4").text();
                 var proindexshow = $(thisobj).index();
                 var proquantityshow = 1;
                 var procurrencyshow = "USD";
                 var procategoryshow = $(thisobj).find(".productcategory_ga4").text();
                 sendProlistname(prolistname);
                 sendProindex(proidshow,prolistname,proindexshow);

                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                             "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }
    // PC flash sale push ga4
      var flashflag={};
  function viewHomeflashlists(){
    var proitems=new Array();
    var blockselction="#homepage-flashsale-container .pc-home-flash .swiper-slide.today-special_item";
    var blocktitle="homepage_flashsale";
    gaviewflashsale(blockselction,proitems,blocktitle,flashflag);
  }
   function viewproflashHandle(){
       viewHomeflashlists();
   }
 window.addEventListener('scroll', GAgdb(viewproflashHandle,1000));
    $("#homepage-flashsale-container .pc-home-flash .swiper-slide.today-special_item").click(function(){
          var prolistname="homepage_flashsale";
              clickpushflashpro(this,prolistname);
     }); 
  // Mobile flash sale push ga4
        var mflashflag={};
  function viewHomemflashlists(){
    var proitems=new Array();
    var blockselction="#homepage-flashsale-container .m-home-flashsale .swiper-slide.product-wheel_item";
    var blocktitle="homepage_flashsale";
    gaviewflashsale(blockselction,proitems,blocktitle,mflashflag);
  }
   function viewpromflashHandle(){
       viewHomemflashlists();
   }
 window.addEventListener('scroll', GAgdb(viewpromflashHandle,1000));
    $("#homepage-flashsale-container .m-home-flashsale .swiper-slide.product-wheel_item").click(function(){
          var prolistname="homepage_flashsale";
              clickpushflashpro(this,prolistname);
     }); 
  // flash sale swiper js
  var flashSwipers = new Swiper('.today-special_swiper' , {
      direction: 'horizontal',
      autoplay: {
		delay: 5000,
		disableOnInteraction: false,
      },
      spaceBetween: 30,
      slidesPerView: 5,
      navigation: {
        nextEl: '.today-special_swiper .swiper-button-prev',
        prevEl: '.today-special_swiper .swiper-button-next',
      }
  });
  // pc qiehuan push ga4
    flashSwipers.on('slideNextTransitionEnd',function(){
      if(GAiiv($("#homepage-flashsale-container"))){
         var proitems=new Array();
          var blockselction="#homepage-flashsale-container .pc-home-flash .swiper-slide.today-special_item";
          var blocktitle="homepage_flashsale";
        gaviewflashsale(blockselction,proitems,blocktitle,flashflag);
      }
  })
    var mobflashSwipers = new Swiper('.m-home-flashsale' , {
      direction: 'horizontal',
      autoplay: {
		delay: 5000,
		disableOnInteraction: false,
      },
      spaceBetween: 10,
      slidesPerView: 2.3,
  });
    // mobile qiehuan push ga4
    mobflashSwipers.on('slideNextTransitionEnd',function(){
      if(GAiiv($("#homepage-flashsale-container"))){
         var proitems=new Array();
        var blockselction="#homepage-flashsale-container .m-home-flashsale .swiper-slide.product-wheel_item";
        var blocktitle="homepage_flashsale";
        gaviewflashsale(blockselction,proitems,blocktitle,mflashflag);
      }
  })
      var urlpage = window.location.href;
   if(urlpage=="https://www.subellahair.com/"){

}
  // product page ga4 push
     if(urlpage.includes('/products/')){
       // tablist-one view
         var protaboneflg ={};
  function viewHometablists(){
  if($(".home-recommend_btn").eq(0).hasClass("active")){
    var proitems=new Array();
     var blockselction="#propage-tablist-container0 .product-grid .grid-item.grid-product";
    var blocktitle="productpage_flashsale";
    gaviewproducts(blockselction,proitems,blocktitle,protaboneflg);
  }
}
   function viewprotabHandle(){
       viewHometablists();
   }
 window.addEventListener('scroll', GAgdb(viewprotabHandle,1000));
       // tablist-one click
      $("#propage-tablist-container0 .product-grid .grid-item.grid-product").click(function(){
          var prolistname="productpage_flashsale";
              clickpushproduct(this,prolistname);
     }); 
        // tablist-two click
      $("#propage-tablist-container1 .product-grid .grid-item.grid-product").click(function(){
          var prolistname="productpage_musthave";
              clickpushproduct(this,prolistname);
     }); 
      // tablist-three click
      $("#propage-tablist-container2 .product-grid .grid-item.grid-product").click(function(){
          var prolistname="productpage_bestsellers";
              clickpushproduct(this,prolistname);
     }); 
       //Recently viewed
            var prorecentflg ={};
  function viewProrecentlists(){
    var proitems=new Array();
     var blockselction="#shopify-section-template--17769700262178__recently-viewed .product-grid .grid-item.grid-product";
    var blocktitle="productpage_RecentlyViewed";
    gaviewproducts(blockselction,proitems,blocktitle,prorecentflg);
}
   function viewprorecentHandle(){
       viewProrecentlists();
   }
 window.addEventListener('scroll', GAgdb(viewprorecentHandle,1000));
        //Recently product click
    $("#RecentlyViewed-container .product-grid .grid-item.grid-product").click(function(){
       console.log("Come on");
          var prolistname="productpage_RecentlyViewed";
          clickpushproduct(this,prolistname);
     }); 
 }
  //product page tablist
         if($(".home-recommend_head .home-recommend_btn.col").length == 0){
            $(".home-recommend_head .home-recommend_btn:eq(0)").addClass("active");
            $('.home-recommend_proBox .recommend_pro-list:eq(0)').css('display','block');
          }
        var protabtwoflags={};
        var protabsanflags={};
        $(".home-recommend_head .home-recommend_btn").click(function(){
            $(this).addClass("active").siblings().removeClass("active");
            $(".home-recommend_proBox .recommend_pro-list").hide().eq($(this).index()).show();
                     //send ga4 event-second tablist product
            if($("#propage-tablist-container .tablist_header1").hasClass("active")){
                    var protwoitems=new Array();
                    var blockselction="#propage-tablist-container1 .product-grid .grid-item.grid-product";
                    var blocktitle="productpage_musthave";
                    gaviewproducts(blockselction,protwoitems,blocktitle,protabtwoflags);      
            }
          //second tablist product-end
                               //send ga4 event-three tablist product
            if($("#propage-tablist-container .tablist_header2").hasClass("active")){
                    var prosanitems=new Array();
                    var blockselction="#propage-tablist-container2 .product-grid .grid-item.grid-product";
                    var blocktitle="productpage_bestsellers";
                    gaviewproducts(blockselction,prosanitems,blocktitle,protabsanflags);
            }
          //three tablist product-end
         })
})
// draw cart ga4 push
 $(function(){
    function isNumber(val){
    var regPos = /^[0-9]+.?[0-9]*/; 
    if(regPos.test(val) ){
        return true;
    }else{
        return false;
    }
  }
    function getListname(productid,provarid){
          var ga_cartInfos=localStorage.getItem("ga_cartInfos");
           if(ga_cartInfos){
                      var objArr=JSON.parse(ga_cartInfos);
                      var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){
                            var prolistname = objInfo.prolname;
                            if(prolistname){
                              return prolistname;
                            }else{
                              return "not set";
                            }  
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
 function getProindex(productid,provarid){
                var ga_proIndex=localStorage.getItem("ga_proIndex");
                if(ga_proIndex){
                   var prolistname = getListname(productid,provarid);
                    var objArr=JSON.parse(ga_proIndex);
                      var flagno = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.productid == productid && objInfo.prolistname == prolistname){
                            return objInfo.proindex;
                        }else{
                          flagno++;
                        }
                    }
                   if(flagno==objArr.length){
                     return 0;
                   }
                }else{
                   return 0;
                }
  }
    function getProname(productid,provarid,protype){
          var ga_cartProm=localStorage.getItem("ga_cartProm");
           if(ga_cartProm){
                      var objArr=JSON.parse(ga_cartProm);
                     var flagno = 0;
                     var flagtwo = 0;
                      for(var i=0;i<objArr.length;i++){
                        var objInfo = objArr[i];
                        if(objInfo.proid == productid){
                          if(objInfo.provarid == provarid){ 
                            if(protype==1){
                              var promoname = objInfo.promotionname;
                              if(promoname){
                                return promoname;
                              }else{
                                return "not set";
                              }
                            }else if(protype==2){
                              var promoid = objInfo.promotionid;
                              if(promoid){
                                return promoid;
                              }else{
                                 return "not set";
                              }
                            }else{
                              return "not set";
                            }
                          }else{
                            flagtwo++;
                          }
                        }else{
                          flagno++;
                        }
                    }
                   var sumflag = flagno+flagtwo;
                   if(sumflag==objArr.length){
                     return "not set";
                   }
                  }else{
                     return "not set";
                  }
    }
 function ckremovega4(){
     console.log("hello444***");
   }
$(".cart__item-sub .js-qty__adjust--minus").on('click', function() {
         
})
   $(".cart__drawer-form .cart__items .cart__item").each(function(){
 
        var precontent = $(this).find(".cart__product-qty").val();
           precontent = parseInt(precontent);
              if(isNumber(precontent)){
                  if(precontent<0){
                    precontent = 1;
                  }else if(precontent==0){
                    precontent = 1;
                  }
              }
     var cartnumno = $(this).index();
     cartnumno=cartnumno+1;
        
      $(this).find(".js-qty__adjust--minus").on('click', function() {
        console.log("hello***"+cartnumno);
           var product_selection = ".cart__drawer-form .cart__items .cart__item:eq("+cartnumno+")";
           var protitleselection= product_selection + " .cart__item-name";
           var pronumselction = product_selection+" .cart__product-qty";
           var pronumshows= $(pronumselction).val();
            pronumshows = parseInt(pronumshows);
              if(isNumber(pronumshows)){
                  if(pronumshows<0){
                    pronumshows = 1;
                  }else if(pronumshows==0){
                    pronumshows = 1;
                  }
              }
     
           var protitleshow = document.querySelector(protitleselection).innerText; 
           var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
           var prolistname = document.querySelector(prolinameselection).innerText;
           var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
           var proskushow = document.querySelector(proskuselection).innerText;
           var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
           var prorealskushow = document.querySelector(prorealskuselection).innerText;
           if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
           }
           var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
           var proidshow = document.querySelector(proidselection).innerText;
           var provariantselection= product_selection + " .cart-provariant";
           var provariantshow = document.querySelector(provariantselection).innerText;
           var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
           var procategoryshow = document.querySelector(procatselection).innerText;
           var propriceselection= product_selection + " .cart__price span[aria-hidden='true'] .money";
           var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');  
           var prosubprice = pronumshows*propriceshow;
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_remove_from_cart",
                  "ecommerce":  {
                     "currency": "USD",
                    "value": prosubprice,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": pronumshows,
                        "currency": "USD"
                      }
                    ]
                  }
              });
      })
       // console.log(cartnumno+"*****"+precontent);
        $(this).find(".cart__product-qty").on('input', function() {
            var aftercontent = $(this).val();
             aftercontent = parseInt(aftercontent);
              if(isNumber(aftercontent)){
                  if(aftercontent<0){
                    aftercontent = 1;
                  }
              }
           var product_selection = "#cartpro-info .click_items"+cartnumno;
           var protitleselection= product_selection + " .cart__product-name";
           var protitleshow = document.querySelector(protitleselection).innerText; 
           var prolinameselection= product_selection + " .cart-product-otherinfo .cart-productlistname ";
           var prolistname = document.querySelector(prolinameselection).innerText;
           var proskuselection= product_selection + " .cart-product-otherinfo .cart-productsku ";
           var proskushow = document.querySelector(proskuselection).innerText;
           var prorealskuselection= product_selection + " .cart-product-otherinfo .cart-productrealsku ";
           var prorealskushow = document.querySelector(prorealskuselection).innerText;
           if(prorealskushow=='' || prorealskushow==null || prorealskushow==undefined || prorealskushow.length == 0){
                    prorealskushow = "not set";
           }
           var proidselection= product_selection + " .cart-product-otherinfo .cart-productid ";
           var proidshow = document.querySelector(proidselection).innerText;
           var provariantselection= product_selection + " .cart-provariant";
           var provariantshow = document.querySelector(provariantselection).innerText;
           var procatselection= product_selection + " .cart-product-otherinfo .cart-productcat ";
           var procategoryshow = document.querySelector(procatselection).innerText;
           var propriceselection= product_selection + " .cart__price span[aria-hidden='true'] .money";
           var propriceshow = document.querySelector(propriceselection).innerText.replace(/[^0-9.]/g, '');
       
          if (aftercontent != precontent) {   
             var subtotal = aftercontent*propriceshow;
             if(aftercontent>precontent){
                   var leftnumcon = aftercontent-precontent;
                subtotal = leftnumcon*propriceshow;

            dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_add_to_cart",
                  "ecommerce":  {
                    "currency": "USD",
                    "value": subtotal,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "promotion_name": getProname(proidshow,provariantshow,1),
                        "promotion_id": getProname(proidshow,provariantshow,2),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": leftnumcon,
                        "currency": "USD"
                      }
                    ]
                  }
              });
             }
            if(aftercontent<precontent){
                var leftnumcon = precontent-aftercontent;
                subtotal = leftnumcon*propriceshow;
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  "event":  "dle_remove_from_cart",
                  "ecommerce":  {
                     "currency": "USD",
                    "value": subtotal,
                    "items": [
                      {
                        "item_name": protitleshow,
                        "item_id": proidshow,
                        "product_sku": prorealskushow,
                        "price": propriceshow,
                        "item_category": procategoryshow,
                        "item_variant": provariantshow,
                        "item_list_name": getListname(proidshow,proskushow),
                        "index": getProindex(proidshow,proskushow),
                        "quantity": leftnumcon,
                        "currency": "USD"
                      }
                    ]
                  }
              });
            }
          }
        });
   })
 })
//  $(function () {
//       var reviewSwipers = new Swiper('#CollectionSection-reviews .swiper-container', {
//         direction: 'horizontal',
//         spaceBetween: 30,
//         slidesPerView: 2, 
//         slidesPerGroup: 2,
//         pagination: {
//             el: '#CollectionSection-reviews .swiper-pagination',
//             clickable: true
//         },
//         breakpoints: {
//             767: {
//                 slidesPerView: 1, 
//                 slidesPerGroup: 1 
//             }
//         }
//     });
//  })